import axios from 'axios';

export default {
  FETCH_PERSONS ({commit, dispatch}, payload){
        return new Promise((resolve, reject) => {
            commit('TOGGLE_LOADING', true);
            // axios.post('login/authenticate', payload)
            axios.get('common/getAllStaff')
                .then((response) => {
                    const { data: { data : { payload } } } = response;
                    localStorage.setItem('persons', JSON.stringify(payload));
                    commit('SET_PERSONS', payload);
                    commit('TOGGLE_LOADING', false);
                    resolve(payload);

                })
                .catch((error) => {
                    console.log('action fetch error : ', error);
                    reject(error);
                    commit('TOGGLE_LOADING', false);
                });
        })
    },
    GETSELECTEDPERSON ({ commit }, personId) {
        commit('TOGGLE_LOADING', true);
        return axios.get(`common/getAllStaff`).then((response) => {
            commit('TOGGLE_LOADING', false);
            const { data: { data : { payload }} } = response;

            console.log('payload', payload)
            let selectedPerson = payload.filter(x => {
              return x.staffId.toString() === personId.toString()
            });

            console.log('found person', selectedPerson)
            commit('SET_SELECTED_PERSON', selectedPerson[0])
        }, (err) => {
            commit('TOGGLE_LOADING', false);
            console.log('err ', err)
        })
    },
    ADD_PERSON({commit, dispatch}, payload){
        return new Promise((resolve, reject) => {
            commit('TOGGLE_LOADING', true);
            console.log("add person payload : ", payload);
            axios.post('common/insertStaffMember', payload)
                .then((response) => {
                    console.log('ADD_PERSON action fetch response : ', response);
                    const { data: { data } } = response;
                    commit('TOGGLE_LOADING', false);
                    resolve(data);
                })
                .catch((error) => {
                    console.log('ADD_PERSON action fetch error : ', error);
                    reject(error);
                    commit('TOGGLE_LOADING', false);
                });
        })
    },
    UPDATE_PERSON({commit, dispatch}, payload){
        return new Promise((resolve, reject) => {
            commit('TOGGLE_LOADING', true);
            axios.post('/common/updateStaffMember', payload)
                .then((response) => {
                    const { data: { data } } = response;
                    commit('TOGGLE_LOADING', false);
                    resolve(data);
                })
                .catch((error) => {
                    console.log('UPDATE_PERSONS action fetch error : ', error);
                    reject(error);
                    commit('TOGGLE_LOADING', false);
                });
        })
    },
  UPDATE_PERSONS_ORDERING ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit('TOGGLE_LOADING', true);
      return axios.put(`common/updStaffDisplayOrder`, payload).then((response) => {
        commit('TOGGLE_LOADING', false);
        const { data: { data } } = response;
        console.log('UPDATE_EXPERT response ', response);
        resolve(data);
      }, (error) => {
        commit('TOGGLE_LOADING', false);
        console.log('UPDATE_EXPERT error ', error);
        reject(error);
      })
    })

  },
}



// WEBPACK FOOTER //
// ./src/store/modules/persons/actions.js